//@ts-ignore
import * as pdfjsLib from "pdfjs-dist";
//@ts-ignore
import * as pdfMake from "pdfmake/build/pdfmake";
//@ts-ignore
import * as pdfFonts from "pdfmake/build/vfs_fonts";
import {useEffect, useMemo, useRef} from "react";
import {Utility} from "../../core/Utility";
import {ButtonInput} from "../ButtonInput/ButtonInput";
import {cloneDeep} from "lodash";
import {useTranslation} from "react-i18next";

(pdfMake as any).vfs = pdfFonts.pdfMake.vfs;
pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

export interface PdfPreviewProps {
    pdfDefinition: any
    documentName?: any
    downloadDocument?: any
    printDocument?: any
};

export const PdfPreview = (p: PdfPreviewProps) => {

    const pdfDefinition = p.pdfDefinition
    const {t} = useTranslation();

    // private pdfContainerRef: any
    let pdfGeneratingQueueLength: number = 0
    let pdfGenerating: boolean | undefined
    let currentGeneratedPdf: any

    const pdfContainerRef = useRef(null)

    useEffect(() => {
        if (p.downloadDocument) {
            p.downloadDocument.current = downloadDocument
            p.printDocument.current = printDocument
        }
    }, [p.pdfDefinition, p.documentName])

    useEffect(() => {
        if (pdfDefinition && pdfContainerRef.current) {
            generatePdf()
        }
    }, [pdfDefinition, pdfContainerRef]);

    const downloadDocument =  () => {
        currentGeneratedPdf = pdfMake.createPdf(Utility.cloneDeep(pdfDefinition))
        let fileName =  p.documentName ? p.documentName : `test.pdf`;
        currentGeneratedPdf.download(fileName);
    }

    const printDocument =  () => {
        currentGeneratedPdf = pdfMake.createPdf(Utility.cloneDeep(pdfDefinition))
        currentGeneratedPdf.print();
    }

    const onDownloadClick = () => {
        downloadDocument()
    };

    const generatePdf = () => {
        pdfGeneratingQueueLength ++
        if (!pdfGenerating) {
            pdfGenerating = false // always generate!!!
            currentGeneratedPdf = pdfMake.createPdf(Utility.cloneDeep(pdfDefinition))
            currentGeneratedPdf.getBuffer(onPdfGenerated)
        }
        else {
            // this.setState({...this.state, pdfGenerating: true})
            // this.state.pdfGeneratingQueueStatus = true
            let me = this
            setTimeout(() => {
                //alert("dodaj")
                if (!pdfGenerating && pdfGeneratingQueueLength > 0) {
                    // this.setState({...this.state, pdfGenerating: false})
                    // me.state.pdfGeneratingQueueStatus = false
                    generatePdf()
                }
            }, 3000)
        }
    };

    const onPdfGenerated = (buff: any) => {
        if(isArrayBuffer(buff)){
            // Fetch the PDF document from the URL using promises.
            let me = this
            const loadingTask = pdfjsLib.getDocument(buff);
            loadingTask.promise.then((pdf: any) => {
                console.log(pdf.numPages)
                clearPdfCanvasContainer()
                for(let i=1,l=pdf.numPages; i<=l; i++){
                    let pageNum = i
                    pdf.getPage(i).then((page: any) => {
                        printPdfPageOnCanvas.apply(me, [page])
                    })
                }
                // me.setState({...this.state, pdfGenerating: false})
                // me.state.pdfGenerating = false
                pdfGenerating = false
                pdfGeneratingQueueLength--
            })
        }
    };

    const isArrayBuffer = (v: any): boolean => {
        return typeof v === 'object' && v !== null && v.byteLength !== undefined
    };

    const printPdfPageOnCanvas = (page: any) => {
        let scale = 1,
            viewport = page.getViewport({scale: scale}),
            canvas: any,
            canvasContainer: any,
            renderContext

        // Prepare canvas using PDF page dimensions.
        canvas = document.createElement('canvas')
        canvas.height = scale * 595 * (297 / 210)
        canvas.width = scale * 600
        canvas.style.border ='2px solid #aaaaaa'
        canvas.style.marginLeft = '0px'
        canvas.style.marginRight = '0px'
        canvas.style.marginTop = '0px'
        canvas.style.marginBottom = '0px'

        canvasContainer = pdfContainerRef

        if (canvasContainer.current) {
            canvasContainer.current.appendChild(canvas)
        }

        // Render PDF page into canvas context.
        renderContext = {
            canvasContext: canvas.getContext('2d'),
            viewport: viewport
        }
        page.render(renderContext)
    };

    const clearPdfCanvasContainer = () => {
        let canvasContainer: any = pdfContainerRef
        if (canvasContainer.current) {
            while (canvasContainer.current.firstChild) {
                canvasContainer.current.removeChild(canvasContainer.current.firstChild)
            }
        }
    };

    return <div style={{width: '100%',height: '100%', marginLeft: '0px'}}>
        <div ref={pdfContainerRef} style={{padding: '0px', width: '100%', overflow: 'auto', margin: "0 auto"}}>{t('Pdf se učitava')}</div>
        {/* <ButtonInput addStyle={{margin: "1rem auto", display: "block"}} labelText="Preuzmi" onButtonClick={onDownloadClick} /> */}
    </div>
};
